import { useEffect, useState } from "react";
import axios from "../../services/Api.js";
import GridIndex from "../../components/GridIndex.jsx";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import { newFacultyFrontEndDomainUrl } from "../../services/Constants.js";
import { Box, IconButton } from "@mui/material";
import useBreadcrumbs from "../../hooks/useBreadcrumbs";
import UserCard from "../../components/UserCard.jsx";
import axiosNoToken from "../../services/ApiWithoutToken.js";

function ImpersonationDept() {
  const setCrumbs = useBreadcrumbs();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [impersonatingUserId, setImpersonatingUserId] = useState(null);

  useEffect(() => {
    setCrumbs([{ name: "Impersonation HOD" }]);
  }, [setCrumbs]);
  const schoolID = JSON.parse(sessionStorage.getItem("userData"))?.school_id;

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await axios.get("/api/fetchHodsBySchool", {
        params: {
          school_id: schoolID,
          page: 0,
          page_size: 1000000,
          sort: "created_date",
        },
      });

      const list = res?.data?.data?.Paginated_data?.content ?? [];
      setRows(list);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to fetch department HODs",
      );
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const handleImpersonate = async (row) => {
    try {
      setImpersonatingUserId(row.user_id);
      const response = await axios.post(`/api/impersonate`, {
        username: row.username,
      });

      const authToken = response?.data?.data?.token;
      const impersonatedUserId = response?.data?.data?.userId;

      if (!authToken || !impersonatedUserId) {
        throw new Error("Something went wrong, Please try again.");
      }

      const roleRes = await axiosNoToken.get(
        `/api/findRoles/${impersonatedUserId}`,
        {
          headers: {
            Authorization: `Bearer ${response.data.data.token}`,
            "ngrok-skip-browser-warning": true,
          },
        },
      );

      const firstRole = roleRes?.data?.data?.[0];
      if (!firstRole) return;

      const userData = {
        login: true,
        userId: impersonatedUserId,
        userName: response.data.data.userName,
        token: authToken,
        isImpersonation: response.data.data.isImpersonation,
        roleId: firstRole.role_id,
        roleName: firstRole.role_name,
        roleShortName: firstRole.role_short_name,
        userType: firstRole.usertype,
        impersonationType: "hod",
      };

      const encodedData = encodeURIComponent(JSON.stringify(userData));
      const nextAppUrl = `${newFacultyFrontEndDomainUrl}/impersonate?token=${encodedData}`;
      window.open(nextAppUrl, "_blank");
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to impersonate user",
      );
    } finally {
      setImpersonatingUserId(null);
    }
  };

  const columns = [
    {
      field: "employee_name",
      headerName: "Employee",
      flex: 1,
      renderCell: (params) => (
        <UserCard
          userId={params.row.user_id}
          label={params.row.employee_name ?? "-"}
        />
      ),
    },
    { field: "empcode", headerName: "Emp Code", flex: 1 },
    { field: "department_name", headerName: "Department", flex: 1 },
    { field: "username", headerName: "Username", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "role_name", headerName: "Role", flex: 1 },
    {
      field: "impersonate",
      headerName: "Impersonate",
      flex: 0.5,
      renderCell: (params) => (
        <IconButton
          label="Impersonate"
          onClick={() => handleImpersonate(params.row)}
          disabled={impersonatingUserId === params.row.user_id}
          sx={{ padding: 0, color: "primary.main" }}
        >
          <TheaterComedyIcon sx={{ fontSize: 22 }} />
        </IconButton>
      ),
    },
  ];

  return (
    <Box sx={{ p: 1 }}>
      <GridIndex
        rows={rows}
        columns={columns}
        loading={loading}
        error={error}
      />
    </Box>
  );
}

export default ImpersonationDept;
